import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Job1 from "../../assets/images/job-ico1.png";
// import Job2 from "../../assets/images/job-ico2.png";
import Job3 from "../../assets/images/job-ico3.png";
import { axiosInstance } from "../../config/https";
import { useLoader } from "../../context/LoaderContext";

export default function ViewProposalComp() {
  const { pathname } = useLocation();
  const isClient = pathname.includes("client");
  const { startLoader, stopLoader } = useLoader();
  const { id } = useParams();
  const [proposal, setProposal] = useState(null);

  useEffect(() => {
    const getJobs = () => {
      startLoader();
      axiosInstance
        .get(`/api/job-proposals/${id}/`)
        .then((resp) => {
          stopLoader();
          const Data = resp.data;
          if (resp.status === 200 || resp.status === 201) {
            setProposal(Data);
          } else {
            toast.warning(Data.msg);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    getJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="view-job pc-p-3">
      <div className="container-fluid px-5">
        <div className="job-detail-box primary-box mt-4">
          <div className="row border-bottom align-items-center pb-3">
            <div className="col-lg-9">
              <div className="primary-heading color-dark">
                <h5 className="mb-3">
                  View {isClient && "Freelancer"} Proposal
                </h5>
                <hr />
                <h4 className="mb-4">{proposal?.job_post_title}</h4>
                <p style={{textAlign: 'justify'}}>{proposal?.cover_letter}</p>
                <div className="row">
                  <div className="col-md-6">
                    <h5>Bid</h5>
                    <h6>{proposal?.bid}</h6>
                  </div>
                  {isClient && (
                    <div className="col-md-6">
                      <h5>Duration</h5>
                      <h6>{proposal?.job_post_length} month</h6>
                    </div>
                  )}
                </div>
                <p className="tag-p">
                  <h5>Skills</h5>
                  {proposal?.seller?.skills.map((e, i) => (
                    <span className="mr-1 text-capitalize" key={i}>
                      {e.name}
                    </span>
                  ))}
                </p>
                {/* <p>The ideal candidate would be:</p>
                <ul className="mb-3">
                  <li>Fluent in English - Quick and responsive</li>
                  <li>Able to communicate in Slack</li>
                  <li>
                    Have the ability to take an example or idea and run with it
                  </li>
                  <li>Eager to understand our industry and target audience</li>
                  <li>Creative and recommend new designs we didn't consider</li>
                </ul>
                <p>
                  Mention the word "academy” at the top of your proposal to be
                  considered.
                </p> */}
              </div>
            </div>
            <div className="col-lg-3 border-left">
              {!isClient && (
                <>
                  <div className="job-specs primary-heading color-dark">
                    <div className="job-specs-icon">
                      <img src={Job1} alt="Job Icon" />
                    </div>
                    <div className="job-specs-content">
                      <h5>Expert</h5>
                      <p>{proposal?.job_post_experience_needed}</p>
                    </div>
                  </div>
                  {/* <div className="job-specs primary-heading color-dark">
              //   <div className="job-specs-icon">
              //     <img src={Job2} alt="Job Icon" />
              //   </div>
              //   <div className="job-specs-content">
              //     <h5>$50.00</h5>
              //     <p>Fixed Price</p>
              //   </div>
              // </div> */}
                  <div className="job-specs primary-heading color-dark">
                    <div className="job-specs-icon">
                      <img src={Job3} alt="Job Icon" />
                    </div>
                    <div className="job-specs-content">
                      <h5>{proposal?.job_post_length} months</h5>
                      <p>Project Length</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
